import { ProductSpotPriceProps } from './@types/ProductSpotPrice';
import IOMessageWithMarkers from '../../native-types/IOMessageWithMarkers';
import FormattedCurrency from '../../format-currency/FormattedCurrency';
import { useCssHandles } from '../../../utils/functions';

const CSS_HANDLES = ['spotPrice', 'spotPriceValue'] as const;
const ProductSpotPrice = ({ message = '', markers = [], blockClass, alwaysShow }: ProductSpotPriceProps) => {
	const spotPriceValue = 359.99;
	const AvailableQuantity = 20;
	const { handles, withModifiers }: any = useCssHandles(`vtex-product-price-1-x`, CSS_HANDLES, blockClass);

	const containerClasses = withModifiers('spotPrice', [alwaysShow && AvailableQuantity <= 0 ? 'isUnavailable' : '']);

	return (
		<span className={containerClasses}>
			<IOMessageWithMarkers
				message={message}
				markers={markers}
				handleBase="spotPrice"
				values={{
					spotPriceValue: (
						<span key="spotPriceValue" className={handles.spotPriceValue}>
							<FormattedCurrency value={spotPriceValue} />
						</span>
					),
				}}
			/>
		</span>
	);
};

export default ProductSpotPrice;
